module.exports = __webpack_public_path__ + "img/logo.a94ff005.png";